/* eslint-disable prefer-template */
/* globals fetch */
import 'isomorphic-fetch';
import $q from 'q';
import _ from 'lodash';

class response {
  static parse(res, type = 'json') {
    switch (type) {
    case 'blob':
      return res.blob();
    case 'json':
      return res.json();
    case 'text':
    default:
      return res.text();
    }
  }

  static hasError(res) {
    return _.has(res, 'errorObj');
  }
}

class http {
  static DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  static prepareBody(body) {
    return _.isObject(body) ? JSON.stringify(body) : body;
  }

  static prepareHeaders(headers, useDefaultHeaders = true) {
    const buildHeaders = useDefaultHeaders ? http.DEFAULT_HEADERS : {};

    if (!headers || !_.isObject(headers)) {
      return buildHeaders;
    }

    return {...buildHeaders, ...headers};
  }

  static requestBuilder(methodType, url, body, headers = {}, useDefaultHeaders = true) {
    const deferred = $q.defer();
    const params = {
      method: methodType,
      headers: http.prepareHeaders(headers, useDefaultHeaders),
    };

    if (methodType !== 'GET') params.body = http.prepareBody(body);

    fetch(url, params).then((res) => {
      if (res.status === 204) {
        return deferred.resolve();
      }

      response.parse(res).then((json) => {
        if (!res.ok) {
          const reqData = {
            ...json,
            statusCode: res.status,
          };
          deferred.reject(reqData);
        }
        deferred.resolve(json);
      }).catch((error) => {
        deferred.reject(error);
      });
    });

    return deferred.promise;
  }

  static post(url, body, headers = {}) {
    return http.requestBuilder('POST', url, body, headers);
  }

  static patch(url, body, headers = {}) {
    return http.requestBuilder('PATCH', url, body, headers);
  }

  static put(url, body, headers = {}) {
    return http.requestBuilder('PUT', url, body, headers);
  }

  static get(url, headers = {}, body) {
    return http.requestBuilder('GET', url, body, headers);
  }

  static delete(url, headers = {}) {
    return http.requestBuilder('DELETE', url, {}, headers);
  }

  static req(url, params) {
    const deferred = $q.defer();

    fetch(url, params).then((res) => {
      if (res.status === 204) {
        http.response.parse(res).then((json) => {
          if (!json) {
            deferred.resolve(res);
          } else {
            deferred.resolve(json);
          }
        });
      } else {
        http.response.parse(res).then((json) => {
          if (!res.ok) {
            const reqData = {
              ...json,
              statusCode: res.status,
            };
            deferred.reject(reqData);
          }
          deferred.resolve(json);
        }).catch((error) => {
          deferred.reject(error);
        });
      }
    });

    return deferred.promise;
  }
}

http.response = response;

export default http;
